import { HttpErrorResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ToastService } from 'src/app/data/services/components/toast/toast.service'
import { ToastSeverity } from '../../enums/components/toast.enum'
import { Toast } from '../../interfaces/components/toast.interface'

export class BlobManagement {
  private toastService: ToastService = inject(ToastService)

  public blobError(httpErrorBlob: HttpErrorResponse): void {
    let errorMessage = this.extractErrorMessage(httpErrorBlob)

    if (!httpErrorBlob.error || !(httpErrorBlob.error instanceof Blob)) {
      this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: errorMessage } as Toast)
      throw new Error(errorMessage)
    }

    const fileBlob = new Blob([httpErrorBlob.error], { type: 'application/json' })
    const fileReader = new FileReader()
    errorMessage = 'Falha ao realizar download do arquivo!'

    fileReader.readAsText(fileBlob)

    fileReader.addEventListener('loadend', (fileProcessed: ProgressEvent<FileReader>) => {
      const result = fileProcessed.target?.result as string

      if (result && result.trim()) {
        try {
          const parsedResult = JSON.parse(result)
          this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: parsedResult?.message || parsedResult?.error || errorMessage } as Toast)
        } catch {
          this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: errorMessage } as Toast)
        }
      } else {
        this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: errorMessage } as Toast)
      }
    })

    fileReader.addEventListener('error', () => {
      errorMessage = 'Falha ao processar resposta de erro do servidor!'
      this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: errorMessage } as Toast)
      throw new Error(errorMessage)
    })
  }

  private extractErrorMessage(httpError: HttpErrorResponse): string {
    if (httpError.error) {
      if (typeof httpError.error === 'string') return httpError.error
      if (typeof httpError.error === 'object') return httpError.error.message || httpError.error.error || httpError.error.detail || 'Erro no servidor'
    }

    if (httpError.status === 404) return 'Arquivo não encontrado!'
    if (httpError.status === 403) return 'Acesso negado ao arquivo!'
    if (httpError.status === 500) return 'Erro interno do servidor!'

    return `Erro ${httpError.status}: ${httpError.statusText || 'Falha ao realizar download do arquivo!'}`
  }

  public blobDownload(blob: Blob, fileName: string): void {
    const link = document.createElement('a')

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)

      link.setAttribute('href', url)
      link.setAttribute('download', fileName)
      link.style.visibility = 'hidden'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  public blobJson(blob: Blob): Observable<any> {
    return new Observable((subscriber) => {
      const fileBlob = new Blob([blob], { type: 'application/json' })
      const fileReader = new FileReader()

      fileReader.onload = (event) => {
        try {
          const result = event?.target?.result as string
          subscriber.next(JSON.parse(result))
          subscriber.complete()
        } catch (error) {
          subscriber.error(error)
        }
      }

      fileReader.onerror = (error) => subscriber.error(error)

      fileReader.readAsText(fileBlob)
    })
  }
}
